<template lang="html">
<div class="pgInner affairs" :style="'height:' + pageH + 'px;'">

      <div class="tabNavs" ref="tabNavs">
           <div v-for="(item,index) in navs" :key="index" @click="tabChange($event,index)" :class="['tabItem',{'act':navAct===index}]">
                {{item}}
           </div>
           <div class="moveLine" :style="lineStr"></div>

           <div class="btns">
                <el-button @click="goFrash" size="mini">刷新</el-button>

                <el-button type="primary" size="mini" @click="upAffairHandle">新建上级事项</el-button>
                <el-button type="primary" size="mini" @click="goEdit('new')">新建事项</el-button>
           </div>
      </div>

      <div class="seekLine">
          <div class="seekGp">
              <el-input @input="reInxList" placeholder="请输入内容" v-model="listParams.keyword">
                    <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
          </div>

          <div v-if="navAct === 0" class="inpGp">
            <dic-select code="ztfl"
                 :selectId="listParams.topicClassificationId"
                 plaText="主题分类"
                 paramsKey="topicClassificationId"
                 @selectChange="selectChange"/>
          </div>

          <div v-if="navAct === 0" class="inpGp">
            <dic-select code="bmfl"
                 :selectId="listParams.departmentClassificationId"
                 plaText="部门分类"
                 paramsKey="departmentClassificationId"
                 @selectChange="selectChange"/>
          </div>

          <div v-if="navAct === 0" class="inpGp">
            <dic-select code="smzqfl"
                 :selectId="listParams.lifeCycleClassificationId"
                 plaText="生命周期分类"
                 paramsKey="lifeCycleClassificationId"
                 @selectChange="selectChange" />
            </el-select>
          </div>

          <div class="inpGp">
            <el-select v-model="listParams.status" clearable placeholder="状态" @change="reInxList()">
              <el-option
                v-for="item in options2"
                :key="item.key"
                :label="item.name"
                :value="item.key">
              </el-option>
            </el-select>
          </div>

          <div class="inpGp">
            <el-select v-model="listParams.status" clearable placeholder="排序" @change="reInxList()">
              <el-option
                v-for="item in options3"
                :key="item.key"
                :label="item.name"
                :value="item.key">
              </el-option>
            </el-select>
          </div>

      </div>

      <div class="pgbody">

          <el-table
             :data="listData"
             header-row-class-name="tableHead"
             v-loading="loading"
             @selection-change="tabSelect"
             style="width: 100%">
             <el-table-column
               type="selection"
               align="center"
               width="30">
             </el-table-column>
             <el-table-column
               prop="title"
               label="标题">
             </el-table-column>

             <el-table-column
               v-if="navAct === 0"
               prop="ptitle"
               width="300"
               align="center"
               label="上级标题">
             </el-table-column>

             <el-table-column
               prop="topicClassification"
               width="180"
               align="center"
               label="主题分类">
             </el-table-column>

             <el-table-column
               prop="departmentClassification"
               width="180"
               align="center"
               label="部门分类">
             </el-table-column>

             <el-table-column
               prop="lifeCycleClassification"
               width="180"
               align="center"
               label="生命周期分类">
             </el-table-column>

             <el-table-column
               label="状态"
               align="center"
               width="120">
                 <template slot-scope="scope">
                      {{ scope.row.status | datFormate(1) }}
                 </template>
             </el-table-column>
             <!-- <el-table-column
               prop="updatedAt"
               width="240"
               align="center"
               label="发布时间">
             </el-table-column> -->
             <el-table-column
               label="操作"
               align="center"
               width="210">

               <template slot-scope="scope">
                  <!-- <div class="ibtn">
                    <span>预览</span>
                    <div class="dvLine"></div>
                  </div> -->
                  <div v-if="scope.row.status==2" class="ibtn">
                    <span @click="goEdit('edit',scope.row)">编辑</span>
                    <div class="dvLine"></div>
                  </div>
                  <div v-if="scope.row.status==2" class="ibtn">
                    <span @click="goRemove(scope.row)">删除</span>
                    <div class="dvLine"></div>
                  </div>
                  <div v-if="scope.row.status==2" class="ibtn">
                    <span @click="changeState(1,scope.row)">上架</span>
                    <div class="dvLine"></div>
                  </div>
                  <div v-if="scope.row.status==1" class="ibtn">
                    <span @click="changeState(2,scope.row)">下架</span>
                    <div class="dvLine"></div>
                  </div>
               </template>

             </el-table-column>
          </el-table>

          <div class="table-footer">

              <div class="btns" v-if="listData.length > 0">
                  <el-button @click="changeState(1)" size="mini">上架</el-button>
                  <el-button @click="changeState(2)" size="mini">下架</el-button>
                  <el-button @click="goRemove()" size="mini" type="danger">删除</el-button>
              </div>


              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="handleCurrentChange"
                :current-page="listParams.no"
                :page-size="listParams.size"
                layout="total, prev, pager, next, jumper"
                :total="allEls">
              </el-pagination>

          </div>

      </div>

      <upAffair v-if="upAffair" @upFrash="upFrash" ref="upAffair" :predat="upPredat" />

</div>
</template>

<script>
import { affList,affRemove,affStatusSet,getUpList } from "@/api/affairs/affairs";
import { dicSeek } from "@/api/pgMent/dictMent";
import upAffair from "./src/upAffair";
export default {
    components:{
        upAffair
    },
    computed:{
      lineStr:function(){
          var str = '';
          if(this.navAct == 1){
             str = 'width:65px;';
          }else {
             str =  'width:32px;';
          }
          str = str + "left:" + this.navX + "px;";
          return str;
      },
    },
    filters:{
        datFormate:function(e,type){
            if(type == 1){    // 状态
                var transMap = {
                    1:'已发布',
                    2:'草稿'
                };
                return transMap[e];
            }
        }
    },
    data(){
        return{
            navs:['政务','上级事项'],
            navX:20,
            navAct:0,
            pageH:'',

            upAffair:true,
            upPredat:'',

            options:[],
            listData:[],
            selectArr:[],

            loading:false,

            listParams:{
              keyword:'',
              topicClassificationId:'',
              departmentClassificationId:'',
              lifeCycleClassificationId:'',
              status:'',
              sort:2,
              no:1,
              size:12
            },

            allPages:0,
            allEls:0,

            options1:[
               { key:1,name:'发布时间正序' },
               { key:2,name:'发布时间倒序' }
            ],

            options2:[
               { key:1,name:'已发布' },
               { key:2,name:'未发布' }
            ],

            options3:[
              { key:1,name:'更新时间倒序' },
              { key:2,name:'更新时间正序' }
            ],

            typeId:''  // 活动通告类型 id
        }
    },
    methods:{
        tabChange:function(e,inx){

            var tabNavs = this.$refs.tabNavs;
            this.navAct = inx;
            this.navX = e.target.offsetLeft;

            this.reInxList();

        },
        getList:function(){
            this.loading = true;
            affList(this.listParams).then(res => {
                this.listData = res.handleMattersList;
                this.loading = false;
                this.allPages = res.totalPages;
                this.allEls = res.totalElements;
            })
        },
        getUpList:function(){
            this.loading = true;
            getUpList(this.listParams).then(res => {
                this.listData = res.handleMattersList;
                this.loading = false;
                this.allPages = res.totalPages;
                this.allEls = res.totalElements;
            })
        },
        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 50;
        },

        goRemove:function(e){     // 批量删除
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }
            if(this.selectArr.length > 0){
                affRemove({ids:this.selectArr}).then(res => {
                    vues.reInxList();
                    vues.selectArr = [];
                })
            }else{
                this.$message.error('请选择删除项！');
            }
        },

        changeState:function(status,e){
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }
            if(this.selectArr.length > 0){
                affStatusSet({ids:this.selectArr,status:status}).then(res => {
                    vues.reInxList();
                    vues.selectArr = [];
                })
            }else{
                this.$message.error('请选择操作项！');
            }
        },

        goEdit:function(type,e){   // 编辑
            var querys = {};
            if(this.navAct === 0){
                if(type == 'edit'){
                    querys.id = e.id;
                }

                this.$router.push({
                    path:'affair_edit',
                    query:querys
                });
            }else{
               this.$refs.upAffair.openstate = true;
               this.$refs.upAffair.predat(e);
            }

        },

        tabSelect:function(e){
            var arrs = [];
            e.forEach(item => {
                arrs.push(item.id);
            })
            this.selectArr = arrs;
        },

        selectChange:function(e){    // 类型
            this.listParams[e.paramsKey] = e.id;
            this.reInxList();
        },

        handleCurrentChange:function(e){
            this.listParams.no = e;
            if(this.navAct === 0){
               this.getList();
            }else{
               this.getUpList();
            }
        },
        reInxList:function(){
            this.listParams.no = 1;
            if(this.navAct === 0){
               this.getList();
            }else{
               this.getUpList();
            }
        },
        prevSet:function(){

            // 底部定位
            this.pageFix();
            this.getList();

        },

        upAffairHandle:function(){    // 新建上级事项
             this.$refs.upAffair.openstate = true;
        },

        upFrash:function(){
             var vues = this;
             vues.upAffair = false;
             vues.$nextTick(() => {
                 vues.upAffair = true;
             })
             vues.reInxList();
        },
        goFrash:function(){
            this.$emit('go-frash');
        }
    },
    created:function(){

        this.prevSet();

    }
}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.tabNavs{
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  background: white;
  position: relative;
  border-bottom: 1px solid #efefef;

  .tabItem{
      display: inline-block;
      margin-right: 30px;
      cursor: pointer;
  }

  .act{
      color: rgb(86, 119, 252);
  }

  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }

  .btns{
     position: absolute;
     right:20px;
     top: 0px;
  }
}

.seekLine{
  padding: 20px;
  background: white;
  .seekGp{
     width: 420px;
     display: inline-block;
  }

  .inpGp{
    width: 150px;
    display: inline-block;
    margin-left: 12px;
  }

  .btns{
    float: right;
    height: 60px;
    margin-top: 12px;
    padding-right: 20px;
  }
}

.pgbody{
  .ibtn{
      display: inline-block;
      font-size: 14px;
      margin-right: 3px;
      span{
         cursor: pointer;
         color: #409EFF;
      }
      .dvLine{
         display: inline-block;
         height: 14px;
         width: 2px;
         vertical-align: middle;
         margin-top: -2px;
         margin-left: 3px;
         background: #EAEAEA;

      }
  }

  .ibtn:last-child .dvLine{
    display: none;
  }

  .table-footer{
    height: 50px;
    background: white;
    padding: 0 30px;
    text-align: right;

    .btns{
      float: left;
      line-height: 50px;
    }

    .paging{
      display: inline-block;
      margin-top: 9px;
    }
  }

}

</style>

<style lang="scss">
.affairs .tableHead th{
   background: #efefef;
   font-weight: normal;
   color: #666666;
}

.affairs .seekLine{

  .el-input__inner{
    border-radius: 0px !important;
  }

  .el-input-group__append{
    border-radius: 0px !important;
  }

}

</style>

<style lang="css">

.affairs .pgbody{
  margin: 20px;
}


@media only screen and (max-width: 1366px) {
    .affairs .pgbody{
        margin: 10px 0;
    }
}

</style>



// WEBPACK FOOTER //
// affairs.vue?4e6e0c89